import { render, staticRenderFns } from "./TheSearchIcon.vue?vue&type=template&id=79935b0b&"
import script from "./TheSearchIcon.vue?vue&type=script&lang=js&"
export * from "./TheSearchIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports